/*
 * Copyright (c) 2024, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Button,
    Divider,
    Stack,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import LoginFields from '../../components/forms/login-fields'
import SocialLogin from '@salesforce/retail-react-app/app/components/social-login'
import {
    continueButton,
    loginFieldsStyle,
    orSignInTextStyle,
    socialMediaLoginStyle
} from './index.style'
import {pxToRem} from '../../utills/pxToRem'
import CTAList from '../cta-list'
import {AbsoluteCenter} from '@chakra-ui/react'

const StandardLogin = ({
    form,
    handleForgotPasswordClick,
    isCustomerSearchLoading,
    handleEmailSubmit,
    handleEditEmailClick,
    hideEmail = false,
    hidePassword = false,
    isSocialEnabled = false,
    setShowPasswordView,
    idps = []
}) => {
    return (
        <Stack spacing={[pxToRem(25), pxToRem(25), pxToRem(20), pxToRem(20)]}>
            <Stack sx={loginFieldsStyle}>
                <LoginFields
                    form={form}
                    hideEmail={hideEmail}
                    hidePassword={hidePassword}
                    handleForgotPasswordClick={handleForgotPasswordClick}
                    handleEditEmailClick={handleEditEmailClick}
                />
            </Stack>
            <Stack
                marginTop={[
                    `${pxToRem(20)} !important`,
                    `${pxToRem(20)} !important`,
                    `${pxToRem(25)} !important`,
                    `${pxToRem(25)} !important`
                ]}
            >
                {hideEmail && (
                    <Button
                        type="submit"
                        onClick={async (e) => {
                            form.clearErrors('global')
                        }}
                        isLoading={form.formState.isSubmitting}
                        sx={continueButton}
                    >
                        <FormattedMessage defaultMessage="Sign In" id="login_form.button.sign_in" />{' '}
                        {' >>'}
                    </Button>
                )}
                {hidePassword && (
                    <Button
                        type="submit"
                        onClick={handleEmailSubmit}
                        isLoading={isCustomerSearchLoading}
                        sx={continueButton}
                    >
                        <FormattedMessage
                            defaultMessage="Sign In/Sign Up"
                            id="login_form.button.signInSignUp"
                        />{' '}
                        {' >>'}
                    </Button>
                )}
                {hidePassword && isSocialEnabled && idps.length > 0 && (
                    <Stack sx={socialMediaLoginStyle}>
                        <Stack position="relative" spacing={6} paddingTop={2} paddingBottom={2}>
                            <Divider />
                            <AbsoluteCenter {...orSignInTextStyle}>
                                <FormattedMessage
                                    defaultMessage="OR Sign in With"
                                    id="login_form.message.or_sign_in_with"
                                />
                            </AbsoluteCenter>
                        </Stack>
                        <SocialLogin form={form} idps={idps} />
                    </Stack>
                )}
                {hidePassword && <CTAList />}
                {/* {hideEmail && (
                    <Button
                        onClick={() => setShowPasswordView(false)}
                        borderColor="gray.500"
                        color="blue.600"
                        variant="outline"
                    >
                        <FormattedMessage
                            defaultMessage="Back to Sign In Options"
                            id="login_form.button.back"
                        />
                    </Button>
                )} */}
            </Stack>
        </Stack>
    )
}

StandardLogin.propTypes = {
    form: PropTypes.object,
    handleEmailSubmit: PropTypes.func,
    handleEditEmailClick: PropTypes.func,
    isCustomerSearchLoading: PropTypes.bool,
    handleForgotPasswordClick: PropTypes.func,
    hideEmail: PropTypes.bool,
    hidePassword: PropTypes.bool,
    isSocialEnabled: PropTypes.bool,
    setShowPasswordView: PropTypes.func,
    idps: PropTypes.arrayOf(PropTypes.string)
}

export default StandardLogin
